<div class="dialog-content">
  <h2 *ngIf="chartTitle === 'monthlyRevenue'">Customer Name:{{selectedCustomer}}</h2>
  <ng-container *ngIf="chartTitle === 'annualSales'; else fullDateRange">
    <h2>Date: {{startYear}}</h2>
  </ng-container>
  <ng-template #fullDateRange>
    <h2>Date Range: {{startYear}} to {{endYear}}</h2>
  </ng-template>
  <h3>
    {{ chartTitle === 'monthlyRevenue'
    ? selectedCustomer + ' by ' + (selectedDataType === 'revenue' ? 'Revenue'
    : selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Purchase Order Values')
    : chartTitle === 'customerDistribution'
    ? 'Top 5 Customers by ' + (selectedDataType === 'revenue' ? 'Revenue'
    : selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Purchase Order Values')
    : chartTitle === 'totalSales'
      ? 'Total Sales for ' + (selectedTotalSalesCustomer === 'all' ? 'All Customers' : selectedTotalSalesCustomer) + ' by ' +
        (selectedDataType === 'revenue' ? 'Revenue'
          : selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Purchase Order Values')
      : chartTitle === 'annualSales'
      ? 'Progress Toward Annual Sales Target for ' + (selectedTotalAnnualSalesCustomer === 'all' ? 'All Customers' : selectedTotalAnnualSalesCustomer) + ' (' +
        (selectedDataType === 'revenue' ? 'Revenue'
          : selectedDataType === 'invoiceValue' ? 'Invoice Values' : 'Purchase Order Values') + ')'
      : 'Unknown Chart' }}
</h3>

  <div class="chart-container">
    <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions" height="400"></p-chart>
  </div>
</div>